const DESKTOP_MEDIA_QUERY = window.matchMedia('(min-width: 750px)');
const instances = new WeakMap();

function layoutOffsetTop(element) {
  let offset = 0;
  let current = element;

  while (current) {
    offset += current.offsetTop;
    current = current.offsetParent;
  }

  return offset;
}

class FireflyProductMediaHeight {
  constructor(grid) {
    this.grid = grid;
    this.details = null;
    this.resourceLinks = null;
    this.mediaGallery = null;
    this.frame = null;
    this.refreshFrame = null;
    this.currentHeight = 0;

    this.scheduleMeasure = this.scheduleMeasure.bind(this);
    this.measure = this.measure.bind(this);

    this.resizeObserver = new ResizeObserver(this.scheduleMeasure);
    this.mutationObserver = new MutationObserver(this.scheduleMeasure);
    this.mutationObserver.observe(this.grid, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    DESKTOP_MEDIA_QUERY.addEventListener('change', this.scheduleMeasure);
    this.measure();
  }

  updateTargets() {
    const details = this.grid.querySelector('.product-details');
    const resourceLinks = this.grid.querySelector('.firefly-product-resource-links');
    const mediaGallery = this.grid.querySelector('.product-information__media > media-gallery.media-gallery--carousel');

    if (details !== this.details) {
      if (this.details) this.resizeObserver.unobserve(this.details);
      this.details = details;
      if (this.details) this.resizeObserver.observe(this.details);
    }

    if (resourceLinks !== this.resourceLinks) {
      if (this.resourceLinks) this.resizeObserver.unobserve(this.resourceLinks);
      this.resourceLinks = resourceLinks;
      if (this.resourceLinks) this.resizeObserver.observe(this.resourceLinks);
    }

    this.mediaGallery = mediaGallery;
  }

  scheduleMeasure() {
    if (this.frame) cancelAnimationFrame(this.frame);
    this.frame = requestAnimationFrame(this.measure);
  }

  scheduleScrollTriggerRefresh() {
    if (!window.ScrollTrigger || this.refreshFrame) return;

    this.refreshFrame = requestAnimationFrame(() => {
      this.refreshFrame = requestAnimationFrame(() => {
        this.refreshFrame = null;
        window.ScrollTrigger.refresh();
      });
    });
  }

  measure() {
    this.frame = null;
    this.updateTargets();

    if (!DESKTOP_MEDIA_QUERY.matches || !this.details || !this.resourceLinks || !this.mediaGallery) {
      if (this.currentHeight !== 0) {
        this.currentHeight = 0;
        this.grid.style.removeProperty('--firefly-product-media-height');
        this.scheduleScrollTriggerRefresh();
      }
      return;
    }

    const galleryTop = layoutOffsetTop(this.mediaGallery);
    const resourceLinksBottom = layoutOffsetTop(this.resourceLinks) + this.resourceLinks.offsetHeight;
    const targetHeight = Math.round(resourceLinksBottom - galleryTop);

    if (targetHeight > 0 && targetHeight !== this.currentHeight) {
      this.currentHeight = targetHeight;
      this.grid.style.setProperty('--firefly-product-media-height', `${targetHeight}px`);
      this.scheduleScrollTriggerRefresh();
    }
  }
}

function initProductMediaHeight(root = document) {
  const grids = root.matches?.('[data-product-grid-content]')
    ? [root]
    : root.querySelectorAll?.('[data-product-grid-content]') || [];

  grids.forEach((grid) => {
    if (instances.has(grid)) return;
    instances.set(grid, new FireflyProductMediaHeight(grid));
  });
}

initProductMediaHeight();

document.addEventListener('shopify:section:load', (event) => {
  initProductMediaHeight(event.target);
});
